export default __webpack_public_path__ + "static/media/fome.35dea848.png";